import { Link } from 'react-router-dom';
import { useCategories } from '../../../hooks/useCategories';

export default function CategorySection() {
  const { categories, loading } = useCategories();

  if (loading) {
    return (
      <section className="py-20 bg-cream-light">
        <div className="max-w-7xl mx-auto px-4 lg:px-8">
          <div className="text-center mb-12">
            <p className="text-gold font-medium text-sm tracking-widest uppercase mb-3">Keşfet</p>
            <h2 className="font-serif text-3xl lg:text-4xl font-bold text-coffee mb-4">Koleksiyonlarımız</h2>
            <div className="w-16 h-0.5 bg-gold mx-auto" />
          </div>
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 lg:gap-6">
            {[1,2,3,4].map(i => (
              <div key={i} className="aspect-[3/4] bg-coffee/10 rounded-2xl animate-pulse" />
            ))}
          </div>
        </div>
      </section>
    );
  }

  if (categories.length === 0) return null;

  return (
    <section className="py-20 bg-cream-light">
      <div className="max-w-7xl mx-auto px-4 lg:px-8">
        <div className="text-center mb-12">
          <p className="text-gold font-medium text-sm tracking-widest uppercase mb-3">Keşfet</p>
          <h2 className="font-serif text-3xl lg:text-4xl font-bold text-coffee mb-4">Koleksiyonlarımız</h2>
          <div className="w-16 h-0.5 bg-gold mx-auto" />
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 lg:gap-6">
          {categories.map((cat, index) => (
            <Link
              key={cat.id}
              to={`/urunler?kategori=${cat.name}`}
              className="group relative overflow-hidden rounded-2xl aspect-[3/4] bg-coffee cursor-pointer"
              style={{ animationDelay: `${index * 100}ms` }}
            >
              {cat.image_url && (
                <img
                  src={cat.image_url}
                  alt={cat.name}
                  className="absolute inset-0 w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-110"
                />
              )}
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent" />
              <div className="absolute inset-x-0 bottom-0 p-5">
                <p className="text-xs text-gold font-medium tracking-wide uppercase mb-1">
                  {cat.product_count} ürün
                </p>
                <h3 className="font-serif text-lg font-bold text-white mb-1 group-hover:text-gold transition-colors">
                  {cat.name}
                </h3>
                <div className="mt-3 flex items-center gap-1 text-gold/80 group-hover:text-gold transition-colors">
                  <span className="text-xs font-medium">Keşfet</span>
                  <i className="ri-arrow-right-line text-sm transition-transform group-hover:translate-x-1" />
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
